exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reports-tab-forms-criminal .reports-tab-criminal-region-selector{width:55%}.reports-tab-forms-criminal .reports-tab-criminal-case-type-selector{width:calc(45% - 10px)}.reports-tab-forms-criminal .reports-tab-criminal-citation-selector{width:45%}.reports-tab-forms-criminal .reports-tab-criminal-date-filter-selector{width:calc(55% - 10px);display:inline-flex}.reports-tab-forms-criminal .reports-tab-criminal-case-flag-selector{width:50%}.reports-tab-forms-criminal .reports-tab-criminal-count-status-selector{width:calc(50% - 10px)}.reports-tab-forms-criminal .reports-tab-criminal-case-properties-selector,.reports-tab-forms-criminal .reports-tab-criminal-include-cvb-cases-selector{width:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/pages/filings/SearchCourtRecords/ReportsTab/ReportsTabForms/Criminal/criminal.less
 ** module id = 1101
 ** module chunks = 0
 **/